import React, { useCallback, useMemo } from "react";
import { DevicePermissionDropdown, DevicePermissionDropdownProps } from "./DevicePermissionsDropdown";
import { AudioDeviceInfo } from "@azure/communication-calling";
import { ConfigurationPageDeviceDropdown } from "./ConfigurationPageDeviceDropdown";
import { DeviceSelectionContainer } from "./DeviceSelectionContainer";


const grantedIconName = 'ControlButtonMicOn';
const notGrantedIconName = 'ControlButtonMicOff';


interface MicrophoneSelectionProps {
    isMobile: boolean;
    permissionGranted: boolean;

    defaultMicrophone?: AudioDeviceInfo;
    microphones: AudioDeviceInfo[];
    selectedMicrophone?: AudioDeviceInfo;
    onSelectMicrophone: (microphone: AudioDeviceInfo) => void;

    roleCanUseMic: boolean;

    dropdownProps: Partial<DevicePermissionDropdownProps>;
    onClickEnableDevicePermission?: () => void;
}

export const MicrophoneSelection = (props: MicrophoneSelectionProps): JSX.Element => {
    const {
        permissionGranted,
        onSelectMicrophone,
        microphones,
    } = props;

    const iconName = useMemo(
        () => (permissionGranted ? grantedIconName : notGrantedIconName),
        [permissionGranted]
    );

    const onSelectMicrophoneCb = useCallback((deviceId: string) => {
        const mic = microphones.find(s => s.id === deviceId);
        onSelectMicrophone(mic!);
    }, [onSelectMicrophone, microphones]);

    const micGrantedDropdown = (
        <>
            {props.roleCanUseMic && (
                <ConfigurationPageDeviceDropdown
                    aria-labelledby={'call-composite-local-sound-settings-label'}
                    deviceAccessGranted={props.permissionGranted}
                    noDevicesLabel={'Keine Mikrofone gefunden'}
                    defaultPlaceHolder={'Mikrophon auswählen'}
                    devices={props.microphones}
                    selectedDevice={props.selectedMicrophone}
                    defaultDevice={props.defaultMicrophone}
                    onSelectDevice={onSelectMicrophoneCb}
                    deviceAccessDeniedLabel={'Keine Mikrofone gefunden'}
                />
            )}
        </>
    );

    const microphoneBlockedDropdown = (
        <DevicePermissionDropdown
            {...props.dropdownProps}
            isMobile={props.isMobile}
            constrain={{ video: false, audio: true }}
            onClick={props.onClickEnableDevicePermission}
        />
    );

    return (
        <DeviceSelectionContainer iconName={iconName}>
            {permissionGranted ? micGrantedDropdown : microphoneBlockedDropdown}
        </DeviceSelectionContainer>
    );
};
